import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { RouterProps, Styled } from "../../../../toolkit/decorators/Artifact";
import { IntegranteResolucionDispatcher } from "../../../containers/comisionesMembresia/integranteResolucion/IntegranteResolucion.dispatcher";
import { IntegranteResolucionStore } from "../../../containers/comisionesMembresia/integranteResolucion/IntegranteResolucion.store";
import IntegranteResolucionAlta from "./IntegranteResolucionAlta";
import IntegranteResolucionEliminado from "./IntegranteResolucionEliminado";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import {
  Inputs,
  InputNames,
  Buttons,
  formConfig
} from "./IntegranteResolucion.form";
import MembresiaIntegranteResolucion from "../../../../types/MembresiaIntegranteResolucion";
import {
  successNotification,
  errorNotification
} from "../../../../utils/notifications";
import s from "./styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

interface Props
  extends IntegranteResolucionDispatcher,
    IntegranteResolucionStore,
    RouterProps {}

interface State {
  tipoBusqueda: string;
  filters: Inputs & {
    periodo: string;
  };
}

@Styled(s)
export default class IntegranteResolucion extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      tipoBusqueda: "",
      filters: {
        periodo: null
      } as any
    };
  }

  componentDidMount() {
    this.props.clearIntegranteResolucion();
  }

  componentWillUnmount() {
    this.props.clearIntegranteResolucion();
  }

  submit = async (values: { [key in InputNames]: any }) => {
    const { tipoBusqueda, folioFactura, mes, anio } = values;

    await this.props.clearIntegranteResolucion();

    if (tipoBusqueda === "FACTURA") {
      const preview = await this.props.getCargosByFolioFactura(folioFactura);

      if (preview.fulfilled) {
        successNotification("Búsqueda de factura realizada correctamente");
        this.setState({
          tipoBusqueda: "FACTURA",
          filters: { ...values, periodo: null }
        });
      } else {
        errorNotification(this.props.gettingIntegranteCargosByFolioError);
      }
    } else {
      const year = anio || new Date().getFullYear();
      const month = mes;
      const periodo = `${year}-${month}-01`;
      const preview = await this.props.getIntegrantesEliminados(periodo);

      if (preview.fulfilled) {
        successNotification(
          "Búsqueda de integrantes eliminados realizada correctamente"
        );
        this.setState({
          tipoBusqueda: "",
          filters: { ...values, periodo }
        });
      } else {
        errorNotification(this.props.gettingIntegrantesEliminadosError);
      }
    }
  };

  handleResolverAlta = async (resolucion: MembresiaIntegranteResolucion) => {
    const preview = await this.props.postResolucionIntegrante(resolucion);

    if (preview.fulfilled) {
      successNotification("Resolución guardada exitosamente");
      const { filters, tipoBusqueda } = this.state;
      if (tipoBusqueda === "FACTURA" && filters.folioFactura) {
        await this.props.getCargosByFolioFactura(filters.folioFactura);
      }
    } else {
      errorNotification(
        this.props.postingIntegranteResolucionError ||
          "Error al guardar la resolución"
      );
    }
  };

  handleReasignarCargo = async (
    idCotizacionItem: number,
    idMembresiaSocioPersona: number
  ) => {
    const preview = await this.props.putReasignarCargoIntegrante(
      idCotizacionItem,
      idMembresiaSocioPersona
    );

    if (preview.fulfilled) {
      successNotification("Cargo reasignado exitosamente");
      const { filters } = this.state;
      if (filters.periodo) {
        await this.props.getIntegrantesEliminados(filters.periodo);
      }
    } else {
      errorNotification(
        this.props.puttingReasignarCargoIntegranteError ||
          "Error al reasignar el cargo"
      );
    }
  };

  render() {
    const {
      integranteCargosByFolio,
      gettingIntegranteCargosByFolio,
      integrantesEliminados,
      gettingIntegrantesEliminados,
      postingIntegranteResolucion,
      puttingReasignarCargoIntegrante
    } = this.props;

    const { tipoBusqueda } = this.state;
    const loading =
      gettingIntegranteCargosByFolio || gettingIntegrantesEliminados;
    const updating =
      postingIntegranteResolucion || puttingReasignarCargoIntegrante;

    return (
      <Container className="animated fadeIn">
        <Row className="mt-3">
          <Col md={12}>
            <p className="text-muted">
              Busque por periodo para ver integrantes eliminados o por factura
              para ver altas de integrantes en membresías existentes.
            </p>
          </Col>
        </Row>

        {/* Formulario de Búsqueda */}
        <div style={{ margin: "0 15px" }}>
          <FormBuilder<InputNames, Buttons>
            config={formConfig}
            submit={this.submit}
            processing={loading && updating}
          />
        </div>

        {/* Spinner de carga */}
        {loading && (
          <Row className="mt-4">
            <Col md={12}>
              <div className="text-center p-4">
                <FontAwesomeIcon spin icon={faSpinner} />
                <p>Espere un momento por favor...</p>
              </div>
            </Col>
          </Row>
        )}

        {/* Altas en Membresías Existentes (Por Factura) */}
        {tipoBusqueda === "FACTURA" && (
          <Row className="mt-4">
            <Col md={12}>
              {integranteCargosByFolio && integranteCargosByFolio.length > 0
                ? integranteCargosByFolio.map((alta, index) => (
                    <IntegranteResolucionAlta
                      key={index}
                      alta={alta}
                      onResolverAlta={this.handleResolverAlta}
                      processingResolucion={
                        this.props.postingIntegranteResolucion
                      }
                    />
                  ))
                : integranteCargosByFolio && (
                    <div className="alert alert-info">
                      No hay altas en membresías existentes para esta factura
                    </div>
                  )}
            </Col>
          </Row>
        )}

        {/* Integrantes Eliminados (Por Periodo) */}
        {tipoBusqueda === "" && (
          <Row className="mt-4">
            <Col md={12}>
              {integrantesEliminados && integrantesEliminados.length > 0
                ? integrantesEliminados.map((eliminacion, index) => (
                    <IntegranteResolucionEliminado
                      key={index}
                      eliminado={eliminacion}
                      onReasignarCargo={this.handleReasignarCargo}
                      processingReasignacion={
                        this.props.puttingReasignarCargoIntegrante
                      }
                    />
                  ))
                : integrantesEliminados && (
                    <div className="alert alert-info">
                      No hay integrantes eliminados para este período
                    </div>
                  )}
            </Col>
          </Row>
        )}
      </Container>
    );
  }
}
